export default {
  DIALOG_WIDTH: 368,
  DIALOG_HEIGHT: 457,
  PANEL_HEIGHT: 48,

  INPUTS_IDS: {
    phoneInput: 'phone-input',
    emailInput: 'email-input',
    linkInput: 'link-input',
    downloadInput: 'download-input',
    pageInput: 'page-input',
    blockInput: 'block-input',
    titleInput: 'title-input',
    actionTypeInput: 'action-type-input',
  },

  DOWNLOAD_OPTIONS_VALUES: {
    downloadOnComputer: 'download-on-computer',
    openInNewTab: 'open-in-new-tab',
  },

  FIELD_NAMES: {
    title: 'title',
    reference: 'reference',
    linkType: 'linkType',
    targetBlank: 'targetBlank',
    nofollowControl: 'nofollowControl',
    download: 'download',
    customPathSwitcher: 'customPathSwitcher',
    customPath: 'customPath',
  },
};
